// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1TiLB","info":"PatientInfo_info__15KSR"};